import request from '@/config/axios'

export interface O2oProviderUiStyleVO {
  styleKey: string
  name: string
  category: string
  primaryColor: string
  surfaceColor: string
  surfaceTopColor: string
  description?: string
  used?: boolean
}

export const O2oProviderUiStyleApi = {
  getList: async () => {
    return await request.get({ url: '/o2o/marketing/provider-ui-style/list' })
  },
  use: async (styleKey: string) => {
    return await request.put({
      url: '/o2o/marketing/provider-ui-style/use?styleKey=' + encodeURIComponent(styleKey)
    })
  }
}
